export default "__VITE_ASSET__8f1acef8__"